module.exports = __webpack_public_path__ + "img/0d6c58f.jpg";